import DynamicClaimForm from './DynamicClaimForm';
import ClaimErrorBoundary from '../ClaimErrorBoundary';

function ClaimSubmission() {
  // Since our DynamicClaimForm handles everything including multi-step flow,
  // document upload, and submission, we just need to render it directly
  return (
    <ClaimErrorBoundary 
      section="Claim Submission Form" 
      customMessage="The claim submission form is experiencing technical difficulties. Your progress will be saved automatically."
    >
      <DynamicClaimForm />
    </ClaimErrorBoundary>
  );
}

export default ClaimSubmission;
